export default "__VITE_ASSET__Cots4llW__"